import { useFormatDate } from '../../../DatePicker/useFormatDates';

export const DatePickerLabel = ({ chipDefaultValue, value }) => {
  const { getFormattedDate } = useFormatDate();

  if (!value) {
    return chipDefaultValue;
  } else {
    return `${getFormattedDate(value, 'MMM d, yyyy')}`;
  }
};

export default DatePickerLabel;
